import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { SystemTool, ToolConfig } from 'data/hooks/agents/types'

type ConfigureToolFormWrapperProps = {
    tool: SystemTool
    config?: ToolConfig
    children: React.ReactNode
    onSubmit: (config: ToolConfig) => void
}

export function ConfigureToolFormWrapper({
    tool,
    config,
    children,
    onSubmit,
}: ConfigureToolFormWrapperProps) {
    const methods = useForm<ToolConfig>({
        defaultValues: config || {
            tool_id: tool.api_name,
            api_name: tool.api_name,
            name: tool.name,
            description: tool.description,
            supplied_inputs: {},
        },
    })

    return (
        <FormProvider {...methods}>
            <form
                onSubmit={(e) => {
                    // this is imporant here because this form may be logically nested
                    // inside other form and we want to make sure that the form is not
                    // submitted when the parent form is submitted
                    e.preventDefault()
                    e.stopPropagation()
                    methods.handleSubmit(onSubmit)(e)
                }}
            >
                {children}
            </form>
        </FormProvider>
    )
}
